module.exports = __webpack_public_path__ + "static/media/frog(1).be80c4da.PNG";